// ======================================================================
// File Name       : UserHistoryStudentDetailCourseTitle
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import RenderField from '../../../utils/ReduxFormUtils';
import { convertNodeGroupToNodeString, convertObjectToList } from '../../../utils/UserUtils';
import PaginationCustom from '../../Pagination';
import * as UserHistoryStudentAction from '../../../actions/UserHistoryStudentAction';
import { RETURN_MAX_NUM, SELECT_TARGET_DATA } from '../../../constants/index';
import ReduxFormPaging from '../../ReduxFormPaging';
import CustomButton from '../../button/CustomButton';

class UserHistoryStudentDetailCourseTitle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courseName: '',
      courseTitleStatus: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    const { courseStatusList } = nextProps;
    const courseSecernId = nextProps.courseSecernId;
    let courseName = '';
    let courseTitleStatus = '';
    if (courseStatusList && courseStatusList.length) {
      const courseSecernIdInForm = nextProps.formValues ? nextProps.formValues.courseSecernId : null;
      const place = courseStatusList.findIndex(o => o.courseSecernId === courseSecernIdInForm);
      if (courseStatusList[place]) {
        courseTitleStatus = courseStatusList[place].courseTitleStatus;
        courseName = courseStatusList[place].courseName;
      }
    }
    this.setState({ courseName, courseTitleStatus });
  }

  render() {
    const { userHistoryStudentDetail } = this.props;
    const { courseName, courseTitleStatus } = this.state;
    const {
      courseStatusList,
      userList,
      userSecernId,
      learningHistoryList,
      courseList,
      learningHistorySortType,
      ascendingDescendingSort,
      onExportFileCSV,
      handleChangeCourse,
    } = this.props;
    return (
      <div>
        <Col sm={12}>
          <Form className='form-horizontal' onSubmit={(e) => { e.preventDefault(); }}>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コース名
              </Col>
              <Col sm={5} className='padding-left-15'>
                <RenderField
                  data={courseStatusList}
                  name="courseSecernId"
                  type="selectbox"
                  valueKey="courseSecernId"
                  nameKey="courseName"
                  handleChangeOption={handleChangeCourse}
                />
              </Col>
              <Col sm={4} className='padding-right-15'>
                <CustomButton
                  btnStyle="btn btn-primary btn-96 float-end"
                  handleClick={onExportFileCSV}
                  text="一括出力"
                  iconClass="bi bi-download"
                />
              </Col>
            </Form.Group>
            <Form.Group className="form-info">
              <Col as={Form.Label} sm={3}>
                コース完了ステータス
              </Col>
              <Col as={Form.Label} sm={8}>
                {courseTitleStatus}
              </Col>
            </Form.Group>
          </Form>
        </Col>
      </div>
    );
  }
}

export default UserHistoryStudentDetailCourseTitle;
